/**
 * Find and Replace — the CCA way to fold the server's corrected rows back into
 * the table.
 *
 * Why a CCA module: the dialog, its three fields, the From / To lists, the
 * "Replace all" rule and the request are the SAME in both products, so they
 * stay in components/eia/findReplaceRules.js and FindReplaceDialog. Only the
 * row the table keeps afterwards differs (legacy ActionButtons.vue
 * handlereplaceAll :285-323): a CCA row keeps quantity and hours as strings,
 * uuid, instance_name and os_type, and takes the server's `adjusted` flag —
 * EIA's merge would instead add uavg / u95 and force `adjusted` to true.
 *
 * Same export name as the EIA rule (mergeCorrectedRows), so the caller picks
 * the module by product.
 */
import { mergeRevalidated, newRowId } from './ccaInstanceRows';

/** One corrected row over the row that was sent; `adjusted` is the server's. */
function mergeCorrected(sent, corrected) {
  return { ...mergeRevalidated(sent, corrected), adjusted: Boolean(corrected?.adjusted) };
}

/**
 * The table after the server's answer. Row for row when it sent back as many
 * rows as it got — each keeps its table id, and fields the server leaves out
 * (OCI OCPU / Memory, which legacy's CCA mapping dropped) survive. Otherwise
 * the answer simply becomes the list, as legacy does. Every row is unsaved.
 *
 * Fixed from legacy: a null quantity / hours no longer crashes `.toString()`
 * (it becomes '' and is flagged by the table), and `Remarks: {}` becomes [].
 */
export function mergeCorrectedRows(sentRows, correctedRows) {
  if (correctedRows.length === sentRows.length) {
    return correctedRows.map((row, i) => mergeCorrected(sentRows[i], row));
  }
  return correctedRows.map((row) => mergeCorrected({ _rowId: newRowId() }, row));
}
